/**
 * Utility for resolving team separator translation keys based on the home/away ordering.
 *
 * @namespace Separator
 * @memberof Mojito.Presentation.Utils
 */

/**
 * Returns a full l10n separator translation key based on homeAway flag.
 *
 * @param {boolean} homeAway - Whether home team is listed first.
 * @returns {string} Full translation key, e.g. '$PARTICIPANT_SEPARATOR.HOME_AWAY'.
 * @function Mojito.Presentation.Utils.Separator#getSeparatorTranslationKey
 */
export function getSeparatorTranslationKey(homeAway) {
    const suffix = homeAway ? 'HOME_AWAY' : 'AWAY_HOME';
    return `$PARTICIPANT_SEPARATOR.${suffix}`;
}
